import { PrimaryGeneratedColumn, Entity, Column, CreateDateColumn, UpdateDateColumn, VersionColumn, Index } from 'typeorm';

@Entity('m_style_operation')
export class StyleOperationsEntity {
    @PrimaryGeneratedColumn('increment',{
        name:'id'
    })
    id: string;

    @Column('varchar', {
        nullable: false,
        length: 20,
        name: 'style_id'
    })
    styleId: string;

    @Column('varchar', {
        nullable: true,
        length: 50,
        name: 'style_name'
    })
    styleName: string;

    @Column('varchar', {
        nullable: false,
        length: 20,
        name: 'operation_id'
    })
    operationId: string;

    @Column('varchar', {
        nullable: false,
        length: 20,
        name: 'operation_code'
    })
    operationCode: string;

    @Column('smallint', {
        nullable: false,
        name: 'operation_order',
        default: 0
    })
    operationOrder: number;

    @Column('smallint', {
        nullable: false,
        name: 'operation_smv',
        default: 0
    })
    operationSmv: number; // in seconds

    @Column('varchar', {
        nullable: true,
        length: 50,
        name: 'stopm_key'
    })
    stopmKey: string;

    @Column('varchar',{
        nullable:false,
        length: 10,
        name:'unit_id'
    })
    unitId: string;

    @Column('varchar', {
        nullable: false,
        length: 10,
        name: 'line_id'
    })
    lineId: string;

    @Column('boolean',{
        nullable:false,
        default: true,
        name:'is_active'
    })
    isActive:boolean;

    @CreateDateColumn({name: 'created_at'})
    createdAt: Date;

    @UpdateDateColumn({name: 'updated_at'})
    updatedAt: Date;
}